export default __webpack_public_path__ + "static/media/git.45c85edf.svg";